import produce from 'immer';
import { handleActions } from 'redux-actions';

const initialState = {};

export default handleActions(
  {
    'ADDRESS/INIT': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        draft[robotId] = {
          FC: null,
          PAYLOADS: {},
        };
      }),
    'ADDRESS/SET_FC': (state, action) =>
      produce(state, (draft) => {
        const { robotId, data } = action.payload;

        draft[robotId].FC = data;
      }),
    'ADDRESS/SET_PAYLOAD': (state, action) =>
      produce(state, (draft) => {
        const { robotId, name, data } = action.payload;

        draft[robotId].PAYLOADS[name] = data;
      }),
    'ADDRESS/REMOVE': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        delete draft[robotId];
      }),
  },
  initialState,
);
